<!--
 * @author xuyiyuan
 * @date 2023-08-17 17:52
 * @description  业务组
-->
<template>
  <div>
    <lsTableLayout>
      <template v-slot:header>
        <a-tabs default-active-key="YJLX0001" :animated="false" v-model="tabsValue">
          <a-tab-pane key="YJLX0001" tab="项目部"></a-tab-pane>
          <a-tab-pane key="YJLX0002" tab="研发组织"></a-tab-pane>
          <a-tab-pane key="YJLX0003" tab="计划组织"></a-tab-pane>
          <a-tab-pane key="YJLX0004" tab="采购组织"></a-tab-pane>
          <a-tab-pane key="YJLX0005" tab="财务组织"></a-tab-pane>
        </a-tabs>
      </template>
      <template v-slot:nav>
        <NavTree ref="businessTree" :customBussinessNo="tabsValue" :treeData="organizationTree" @onSelectTree="getDetail" @addGetDetail="addGetDetail"></NavTree>
      </template>
      <template v-slot:table>
        <div class="h92-vh">
          <template v-if="showDetail">
            <ls-card :title="groupDetailIs?'业务组详情':'业务组织详情'">
              <div>基本信息</div>
              <ls-info-form :splitNumber="4">
                <ls-info-item :title="groupDetailIs?'业务组编码':'业务组织编码'" :value="businessGroupMsg.teamNo" slot="teamNo" :IsContentTip="true" placement="topLeft" />
                <ls-info-item :title="groupDetailIs?'业务组名称':'业务组织名称'" :value="businessGroupMsg.teamName" slot="teamName" :IsContentTip="true" placement="topLeft" />
                <ls-info-item title="职能类型" :value="businessGroupMsg.functionType" slot="functionType" :IsContentTip="true" placement="topLeft" />
                <!--业务组详情展示上级业务组-->
                <ls-info-item title="上级业务组" v-if="level==3" :value="businessGroupMsg.teamParentName" slot="teamParentName" :IsContentTip="true" placement="topLeft" />
                <!--只业务组织显示-->
                <ls-info-item title="公司主体" v-if="level==2" :value="businessGroupMsg.companyNoName" slot="companyNoName" :IsContentTip="true" placement="topLeft" />
                <ls-info-item title="外部编码" v-if="level==2" :value="businessGroupMsg.externalCoding" slot="externalCoding" :IsContentTip="true" placement="topLeft" />
                <ls-info-item title="状态" :value="GROUP_STATUS_ENU[businessGroupMsg.status]" slot="status" :IsContentTip="true" placement="topLeft" />
                <ls-info-item title="关联行政部门" :value="businessGroupMsg.authDepartment" slot="authDepartment" :IsContentTip="true" placement="topLeft" />
                <ls-info-item title="说明" :value="businessGroupMsg.remark" slot="remark" :IsContentTip="true" placement="topLeft" />
              </ls-info-form>
              <template v-if="groupDetailIs || tabsValue === 'YJLX0001'">
                <a-divider />
                <a-tabs default-active-key="1" :animated="false" v-model="subTabsValue">
                  <a-tab-pane key="1" tab="员工列表"></a-tab-pane>
                  <a-tab-pane key="3" tab="数据权限" v-if="businessGroupMsg.level === '3'"></a-tab-pane>
                </a-tabs>
                <template v-if="subTabsValue==='1'">
                  <ls-api-table
                    ref="dataTable"
                    :columns="columns"
                    :tableProps="tableProps"
                    :scroll="{ fixScreen: true }"
                  >
                  </ls-api-table>
                </template>
                <template v-if="subTabsValue==='3'">
                  <data-permissions :rowId="businessGroupMsg.rowId"/>
                </template>
              </template>
            </ls-card>
          </template>
        </div>

      </template>
    </lsTableLayout>
  </div>
</template>

<script>

import { selectStaffByTeamNo } from '@/api/system/businessGroup'
import { generateLsTableResData } from '@/utils/util.js'
import NavTree from './components/nav-tree.vue'
import { GROUP_STATUS_ENU } from "./enums";
import DataPermissions from "./components/data-permissions";

export default {
  name: 'BusinessGroup',
  components: {
    DataPermissions,
    NavTree
  },
  data () {
    return {
      GROUP_STATUS_ENU,
      organizationTree: [],
      businessGroupMsg: {},
      teamNo: '',
      level: null,
      // teamLevel: null,
      groupDetailIs: false,
      columns: [
        {
          title: "员工",
          dataIndex: "personalName"
        },
        {
          title: "邮箱",
          dataIndex: "email"
        },
        {
          title: "电话",
          dataIndex: "phone"
        },
        {
          title: "是否主管",
          dataIndex: "directorIs",
          customRender: text => text === 1 ? '是' : text === 0 ? '否' : ''
        }
      ],
      tableProps: {
        requestApi: generateLsTableResData(selectStaffByTeamNo, true),
        pageCurrent: true
      },
      // 头部项目部、研发组织、计划组织、采购组织、财务组织，默认项目部
      tabsValue: 'YJLX0001',
      // 详情下员工列表、职责范围、数据权限，默认员工列表
      subTabsValue: '1',
      showIs: false, // 用来区分是点加号还是点nav
      showDetail: false // 只要点击过nav就复制，防止用teamNo判断显示详情，导致点击加号显示详情但没有数据
    }
  },
  activated () {
    this.getTreeData()
  },
  mounted () {
    this.getTreeData()
  },
  methods: {
    getTreeData () {
      this.$refs.businessTree.handlerTreeData()
    },
    // 获取业务组详情
    async getDetail (data) {
      this.groupDetailIs = false
      this.teamNo = data.value
      this.level = data.level // level层级1：职能部门，2业务组织，3业务组
      this.showIs = data.showIs // true为加号点击，false为正常选中
      this.subTabsValue = '1' // 每次都重置下成员工列表
      if (data.level === '1') { // 当层级为1时不需要查接口
        return false;
      } else if (data.level === '2') {
        // 当层级为2时调查业务组织详情接口
        this.showDetail = true
        this.businessGroupMsg = data.props
        if (this.tabsValue === 'YJLX0001' && !this.showIs) {
          this.$nextTick(() => { // 业务组层级的刷新人员列表
            this.$refs.dataTable.searchParams = { teamNo: this.teamNo, page: 1, pageSize: 20 }
            this.$refs.dataTable.getData();
          })
        }
      } else if (data.level === '3') {
        // 当层级为3时调业务组详情接口
        this.groupDetailIs = true
        this.showDetail = true
        this.businessGroupMsg = data.props
        this.$nextTick(() => { // 业务组层级的刷新人员列表
          this.$refs.dataTable.searchParams = { teamNo: this.teamNo, page: 1, pageSize: 20 }
          this.$refs.dataTable.getData();
        })
      }
    },
    // 加号点击的操作,因为数据需要获取详情数据，但详情已经绑定了很多teamNo，所以以下方法会有冗余
    async addGetDetail (data) {

    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-tabs-bar{
  margin: 0;
}
.h92-vh {
  height: 92vh
}
</style>
